import { render, staticRenderFns } from "./cd-chat-header.vue?vue&type=template&id=72dbc872&scoped=true"
import script from "./cd-chat-header.vue?vue&type=script&lang=js"
export * from "./cd-chat-header.vue?vue&type=script&lang=js"
import style0 from "./cd-chat-header.vue?vue&type=style&index=0&id=72dbc872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dbc872",
  null
  
)

export default component.exports